<template>
  <div
    ref="editor"
    style="width:100%; height: 100%"
    type="text"
    :disabled="disabled"
    :maxlength="schema.max"
    :placeholder="schema.placeholder"
    :readonly="schema.readonly"
  ></div>
</template>

<script>
import { abstractField } from "vue-form-generator";
import JSONEditor from "jsoneditor";

export default {
  mixins: [abstractField],
  data() {
    return {
      editor: null
    };
  },
  mounted() {
    // console.log('=============')
    // console.log(this.model)
    // console.log(this.schema)
    // console.log(this.model[this.schema.model]);
    // console.log('XXXXXXXXXXXX')
    this.editor = new JSONEditor(this.$refs.editor, {
        search: false,
        mainMenuBar: true,
        navigationBar: false,
        statusBar: false,
        onChange: () => {
            this.value = this.editor.get();
        }
    });
    this.editor.set(this.value);
  }
};
</script>

<style></style>
